import { render, staticRenderFns } from "./BaseTransactionTabs.vue?vue&type=template&id=af8d8a9e&"
import script from "./BaseTransactionTabs.vue?vue&type=script&lang=js&"
export * from "./BaseTransactionTabs.vue?vue&type=script&lang=js&"
import style0 from "./BaseTransactionTabs.vue?vue&type=style&index=0&id=af8d8a9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports